import { Fragment } from 'react';

import DataGrid from '@/components/elements/lists/DataGrid';
import { _t } from '@/locale';
import { CheckoutDetailsGiftcard } from '@/types/checkout';

type Props = {
  baseTranslationKey:
    | 'components.modules.checkout.CheckoutDetails'
    | 'components.modules.appointment.AppointmentDetailsSummary';
  giftcards?: CheckoutDetailsGiftcard[];
  withRemove?: boolean;
};

const PaymentDetailsGiftCardList = ({ giftcards, baseTranslationKey, withRemove }: Props) => {
  if (!giftcards || giftcards.length === 0) {
    return null;
  }

  return (
    <>
      {giftcards?.map(({ code, amount, expiryDate, label, onRemove }) => {
        return (
          <Fragment key={code}>
            <DataGrid.Row hasPaddingTop>
              <DataGrid.Cell title={label} type="default" />
              <DataGrid.Cell
                title={amount}
                align="right"
                type="default"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.giftcard.discount`)}
              />
            </DataGrid.Row>
            <DataGrid.Row underline>
              <DataGrid.Cell
                title={
                  <span className="gap-sm flex flex-nowrap items-center">
                    <span className="text-nowrap">{code}</span>
                    {onRemove && withRemove && (
                      <button
                        className="text-fg_negative text-nowrap underline"
                        onClick={() => {
                          onRemove(code);
                        }}>
                        {_t(`${baseTranslationKey}.giftcard.removeGiftcard`)}
                      </button>
                    )}
                  </span>
                }
                type="description"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.giftcard.code`)}
              />
              <DataGrid.Cell
                title={
                  <span className="text-fg_secondary text-m">
                    {expiryDate ? ` ${_t('expires')}: ${expiryDate}` : ''}
                  </span>
                }
                type="muted"
                align="right"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.giftcard.code`)}
              />
            </DataGrid.Row>
          </Fragment>
        );
      })}
    </>
  );
};

export default PaymentDetailsGiftCardList;
